'use strict';

/**
 * Component for the proper name
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/components/field-string.hbs');

var StringComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);
        this.reset();
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        this.render();
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        data[field.name] = this.$('[name="' + field.name + '"]').val().trim();

        return data;
    },
});

module.exports = StringComponent;